 <template>
    <div class="maskbg">
        <div class="dialog jtjs">
            <div class="close" @click="handleClose"></div>
            <div class="infoDig">
                <div class="main">
                    <div class="part">
                        <h3>{{info.name}}</h3>
                        <p>{{info.intro}}</p>
                    </div>
                    <div class="part">
                        <h3 v-if="info.leader">总经理（{{info.leader}}）</h3>
                        <p>{{info.leaderIntro}}</p>
                    </div>
                </div>
            </div>
            <ul class="flx-bc btnBox">
                <li class="btn" :class="item.name===info.name?'active':''" v-for="(item,index) in datas" :key="index" @click="change(item)">{{item.name}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    components: {},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        datas: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            info: {}
        }
    },
    created() {
        this.info = this.datas[0]
    },
    mounted() {
    },
    methods: {
        change(val){
            this.info = val
        },
        handleClose(){
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common';
@import '@/styles/dialog';
</style>